import { render } from "./pharmacy-register-step3.vue?vue&type=template&id=585c78d8"
import script from "./pharmacy-register-step3.vue?vue&type=script&lang=js"
export * from "./pharmacy-register-step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__